import { Injectable } from '@angular/core';
import { EncField, Encoding, ModifyField } from '@mode-vegas/vegas';
import { EncodingHelpers, FieldFormatHelpers, VegasFrame } from '@mode/charts/util-vegas';
import { ChartTypes, FlamingoTypes } from '@mode/shared/contract-common';
import { UpdateFieldService } from '../encoding-field/update-field.service';
import { CompiledField } from '@mode/shared/util-switch';
import { ExprForm } from '@mode-switch/express';

@Injectable({
  providedIn: 'root',
})
export class UpdateSingleFieldService extends UpdateFieldService {
  selectFieldToFormat(field: EncField) {
    this.chartFacade.viewCalcFieldSetFieldToFormat(field);
  }

  updateFieldEncoding(
    view: FlamingoTypes.ModeView,
    encoding: Encoding,
    originalField: EncField,
    modifiedField: ModifyField
  ) {
    return EncodingHelpers.updateVegasFieldEncoding(view, encoding, modifiedField);
  }

  clearFrame(encoding: Encoding, field: EncField) {
    return EncodingHelpers.clearFrame(encoding, field.id);
  }

  makeFieldFormatsForTrend(trend: ExprForm | null, encoding: Encoding, field: EncField, view: FlamingoTypes.ModeView) {
    let fieldFormats: ChartTypes.FieldFormatMap | undefined = undefined;
    const fieldId = field.id;

    if (fieldId == null) {
      return;
    }
    // Set the proper frame direction
    const encField = EncodingHelpers.getEncFieldById(encoding, fieldId);
    let encResult = EncodingHelpers.loadEncoding(encoding);
    if (encField) {
      const compiledField = CompiledField.fromEncField(view, encField);
      const frame = VegasFrame.makeDefaultExprFrame(encoding, compiledField);
      encResult = EncodingHelpers.setFrame(encoding, fieldId, frame);

      if (trend === ExprForm.PctDifference || trend === ExprForm.PctOfTotal) {
        // Set the format to percent
        fieldFormats = FieldFormatHelpers.buildQuickCalcPercentFormat(encField);
      }
    }
    return { encResult, fieldFormats };
  }

  makeFieldFormatsForTableCalc(originalField: EncField, formula: CompiledField, encoding: Encoding) {
    // Set the format to percent if the formula was _changed_ to a Pct* formula
    let fieldFormats: ChartTypes.FieldFormatMap | undefined;
    const isPctFormula = formula.form === ExprForm.PctDifference || formula.form === ExprForm.PctOfTotal;
    if (isPctFormula) {
      const encField = EncodingHelpers.getEncFieldById(encoding, originalField.id ?? '');
      if (encField) {
        fieldFormats = FieldFormatHelpers.buildQuickCalcPercentFormat(encField);
      }
    }
    return fieldFormats;
  }
}
